/**
 * What a Timeline shows, the same for a Widget's own entries and for a Timeline Provider's answer.
 *
 * A Provider may run in a Module of ours, in an outside Module, or answer from an Add-on behind a Site
 * route, so the entry is spelled here rather than in the UI package: every end that hands entries over
 * reads and writes this shape.
 */
/** What an entry's mark says about it: a word about meaning, so the Theme decides the colour. */
export const PHI_TIMELINE_TONES = ["secondary", "success", "warning", "danger"];
function readString(value) {
    return typeof value === "string" && value.trim().length > 0 ? value.trim() : undefined;
}
export function isPhiTimelineTone(value) {
    return typeof value === "string" && PHI_TIMELINE_TONES.includes(value);
}
/**
 * The `at` of an entry, when it is a date this reader can place. A string that is not one is dropped
 * rather than shown: an unreadable instant would print as "Invalid Date" in the reader's language.
 */
function readInstant(value) {
    const text = readString(value);
    return text && !Number.isNaN(Date.parse(text)) ? text : undefined;
}
/** One entry, or `null` for anything that is not one. An entry without a key or text is not one. */
export function readPhiTimelineEntry(value) {
    if (!value || typeof value !== "object" || Array.isArray(value)) {
        return null;
    }
    const record = value;
    const key = readString(record.key);
    if (!key) {
        return null;
    }
    const title = readString(record.title);
    const at = readInstant(record.at);
    const time = readString(record.time);
    const icon = readString(record.icon);
    return {
        key,
        content: typeof record.content === "string" ? record.content : "",
        ...(title ? { title } : {}),
        ...(at ? { at } : {}),
        ...(time ? { time } : {}),
        ...(icon ? { icon } : {}),
        ...(isPhiTimelineTone(record.tone) ? { tone: record.tone } : {}),
        ...(record.pending === true ? { pending: true } : {}),
    };
}
export function readPhiTimelineEntries(value) {
    return Array.isArray(value)
        ? value.map(readPhiTimelineEntry).filter((entry) => entry != null)
        : [];
}
